import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export type mediaMentionProps = {
  publicationLogo: string;
  title: string;
  publicationDate?: string;
  description: string;
  alt_text?: string;
  url: string;
};

export const featuredMediaMentionMapping = (mediaMentionData) => {
  if (!mediaMentionData || mediaMentionData.length === 0) {
    return null;
  }
  const mappedMediaMentions = mediaMentionData?.map((item: any) => {
    if (!item.fields) {
      return null;
    }
    let mediaMentionDescription = '';
    // check if item.fields?.bodyText is an object or a string
    if (typeof item?.fields?.description === 'object') {
      mediaMentionDescription = documentToPlainTextString(item?.fields?.description);
    } else {
      mediaMentionDescription = item?.fields?.description;
    }
    // truncate description to 300 characters
    if (mediaMentionDescription && mediaMentionDescription.length > 300) {
      mediaMentionDescription = `${mediaMentionDescription.substring(0, 300)}...`;
    }

    const publicationDate = item.fields?.publicationDate
      ? item.fields?.publicationDate
      : item.sys?.createdAt;

    return {
      key: item.sys.id,
      title: item.fields?.title,
      description: mediaMentionDescription,
      url: item.fields?.url,
      publicationDate: publicationDate,
      publicationLogo: item.fields?.publicationLogo?.fields?.file.url,
    };
  });

  return mappedMediaMentions;
};
